import React, { useState } from 'react';
import { Menu, X, TrendingUp, Search, ChevronDown } from 'lucide-react';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPlatformMenuOpen, setIsPlatformMenuOpen] = useState(false);
  
  // Get domain from environment variable with default fallback
  const agniDomain = process.env.REACT_APP_AGNI_DOMAIN || 'agni.cash';

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const togglePlatformMenu = () => {
    setIsPlatformMenuOpen(!isPlatformMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <TrendingUp className="logo-icon" />
            <span className="logo-text">Agni</span>
          </div>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <a href="#home" className="nav-link">Home</a>
            <a href="#strategies" className="nav-link">Strategies</a>
            <a href="#insights" className="nav-link">Insights</a>
            <a href="#community" className="nav-link">Community</a>
            <a href="#blog" className="nav-link">Blog</a>
          </nav>

          <div className="header-actions">
            <div className="search-container">
              <Search className="search-icon" />
              <input 
                type="text" 
                placeholder="Search strategies, insights..." 
                className="search-input"
              />
            </div>
            <div className="platform-dropdown">
              <button 
                className="btn btn-primary platform-cta"
                onClick={togglePlatformMenu}
              >
                Access Tools
                <ChevronDown className="dropdown-icon" />
              </button>
              {isPlatformMenuOpen && (
                <div className="platform-menu">
                  <a 
                    href={`https://trading.${agniDomain}/`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="platform-link"
                  >
                    Options Platform
                  </a>
                  <a 
                    href={`https://devtrading.${agniDomain}/`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="platform-link"
                  >
                    FNO Tools
                  </a>
                  <a 
                    href="#crypto" 
                    className="platform-link"
                  >
                    Crypto Analysis
                  </a>
                </div>
              )}
            </div>
            <button 
              className="menu-toggle"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
